"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BrandsLandingsList_1 = require("./component/BrandsLandingsList");
var BrandLandingEditor_1 = require("./component/BrandLandingEditor");
var BrandLandingCountryList_1 = require("./component/country/BrandLandingCountryList");
var BrandLandingCountryEditor_1 = require("./component/country/BrandLandingCountryEditor");
var BrandLandingLocaleList_1 = require("./component/locale/BrandLandingLocaleList");
var BrandLandingLocaleEditor_1 = require("./component/locale/BrandLandingLocaleEditor");
var PBrandsLandingsList = /** @class */ (function (_super) {
    __extends(PBrandsLandingsList, _super);
    function PBrandsLandingsList(props) {
        return _super.call(this, props) || this;
    }
    PBrandsLandingsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.availBrandsList.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.availCountryList.Subscribe("*", function (id, data) {
            _this.setState({ avail_country: data.data });
        });
        this.SID_AL = this.props.availLanguageList.Subscribe("*", function (id, data) {
            _this.setState({ avail_language: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            recordRoot: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_formats: [],
            avail_geometry: [],
            avail_brands: [],
            avail_country: [],
            avail_language: []
        }, function () {
            _this.props.availBrandsList.LoadData();
            _this.props.availCountryList.LoadData();
            _this.props.availLanguageList.LoadData();
        });
    };
    PBrandsLandingsList.prototype.componentWillUnmount = function () {
        this.props.availBrandsList.UnSubscribe(this.SID_AB);
        this.props.availCountryList.UnSubscribe(this.SID_AC);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.availLanguageList.UnSubscribe(this.SID_AL);
    };
    PBrandsLandingsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", recordRoot: null });
    };
    PBrandsLandingsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", recordRoot: val });
    };
    PBrandsLandingsList.prototype.onGoBackToRootClick = function () {
        this.setState({ edit_mode: "LIST", recordRoot: null });
    };
    PBrandsLandingsList.prototype.onConfigClick = function (val) {
        this.setState({ edit_mode: "COUNTRY-LIST", recordRoot: val });
    };
    PBrandsLandingsList.prototype.onNewCountryClick = function () {
        this.setState({ edit_mode: "COUNTRY-NEW", recordCountry: null });
    };
    PBrandsLandingsList.prototype.onEditCountryClick = function (val) {
        this.setState({ edit_mode: "COUNTRY-EDIT", recordCountry: val });
    };
    PBrandsLandingsList.prototype.onGoBackToCountryListClick = function () {
        this.setState({ edit_mode: "COUNTRY-LIST", recordCountry: null });
    };
    PBrandsLandingsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PBrandsLandingsList.prototype.onBackToLocalesClick = function () {
        this.setState({ edit_mode: "LOCALE-LIST" });
    };
    PBrandsLandingsList.prototype.onTranslateClick = function (val) {
        this.setState({ edit_mode: "LOCALE-LIST", recordRoot: val });
    };
    PBrandsLandingsList.prototype.onNewLocaleClick = function () {
        this.setState({ edit_mode: "LOCALE-NEW", recordLocale: null });
    };
    PBrandsLandingsList.prototype.onEditLocaleClick = function (val) {
        this.setState({ edit_mode: "LOCALE-EDIT", recordLocale: val });
    };
    PBrandsLandingsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PBrandsLandingsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BrandLandingEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackToRootClick.bind(this), brandsAvail: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BrandLandingEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.recordRoot, onGoBack: this.onGoBackToRootClick.bind(this), brandsAvail: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BrandsLandingsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfigClick.bind(this), onTranslateClick: this.onTranslateClick.bind(this) }));
        }
        if (this.state.edit_mode === "COUNTRY-LIST") {
            return (React.createElement(BrandLandingCountryList_1.default, { data: this.props.dataCountry, state: this.props.state, onNewClick: this.onNewCountryClick.bind(this), onEditClick: this.onEditCountryClick.bind(this), rootRecord: this.state.recordRoot, onGoBackClick: this.onGoBackToRootClick.bind(this) }));
        }
        if (this.state.edit_mode === "COUNTRY-EDIT") {
            return (React.createElement(BrandLandingCountryEditor_1.default, { data: this.props.dataCountry, state: this.props.state, rootRecord: this.state.recordRoot, record: this.state.recordCountry, onGoBack: this.onGoBackToCountryListClick.bind(this), availCountry: this.state.avail_country }));
        }
        if (this.state.edit_mode === "COUNTRY-NEW") {
            return (React.createElement(BrandLandingCountryEditor_1.default, { data: this.props.dataCountry, state: this.props.state, rootRecord: this.state.recordRoot, record: null, onGoBack: this.onGoBackToCountryListClick.bind(this), availCountry: this.state.avail_country }));
        }
        if (this.state.edit_mode === "LOCALE-LIST") {
            return (React.createElement(BrandLandingLocaleList_1.default, { data: this.props.dataLocales, state: this.props.state, onNewClick: this.onNewLocaleClick.bind(this), onEditClick: this.onEditLocaleClick.bind(this), rootRecord: this.state.recordRoot, onGoBackClick: this.onGoBackToRootClick.bind(this) }));
        }
        if (this.state.edit_mode === "LOCALE-EDIT") {
            return (React.createElement(BrandLandingLocaleEditor_1.default, { data: this.props.dataLocales, state: this.props.state, rootRecord: this.state.recordRoot, record: this.state.recordLocale, onGoBack: this.onBackToLocalesClick.bind(this), availLanguage: this.state.avail_language }));
        }
        if (this.state.edit_mode === "LOCALE-NEW") {
            return (React.createElement(BrandLandingLocaleEditor_1.default, { data: this.props.dataLocales, state: this.props.state, rootRecord: this.state.recordRoot, record: null, onGoBack: this.onBackToLocalesClick.bind(this), availLanguage: this.state.avail_language }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PBrandsLandingsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PBrandsLandingsList.getPageDescription = function (state) {
        return {
            icon: "plane",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_brands_landings + "-id",
            itemTitle: "Лендинги",
            route: routes_1.routes.page_par_brands_landings,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PBrandsLandingsList;
}(React.Component));
exports.default = PBrandsLandingsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_landings_list/ui/PBrandsLandingsList.tsx
// module id = 2415
// module chunks = 0